<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    class="text-[#3176FF]"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.3385 9.0013C17.3385 13.6037 13.6076 17.3346 9.00521 17.3346C4.40284 17.3346 0.671875 13.6037 0.671875 9.0013C0.671875 4.39893 4.40284 0.667969 9.00521 0.667969C13.6076 0.667969 17.3385 4.39893 17.3385 9.0013ZM9.00521 7.54297C9.35039 7.54297 9.63021 7.82279 9.63021 8.16797V13.168C9.63021 13.5131 9.35039 13.793 9.00521 13.793C8.66003 13.793 8.38021 13.5131 8.38021 13.168V8.16797C8.38021 7.82279 8.66003 7.54297 9.00521 7.54297ZM9.00521 6.5013C9.46545 6.5013 9.83854 6.12821 9.83854 5.66797C9.83854 5.20773 9.46545 4.83464 9.00521 4.83464C8.54497 4.83464 8.17188 5.20773 8.17188 5.66797C8.17188 6.12821 8.54497 6.5013 9.00521 6.5013Z"
      fill="currentColor"
    />
  </svg>
</template>
